import { ReactNode } from 'react';

import { Typography } from '@rrexpress/core';

import classJoin from '@/utility/helper/classJoin';

import { RenderIf } from '../conditional/render-if';

export function DataDisplay(props: { label: string, value?: string }) {
  return (
    <div className="flex items-baseline">
      <div className="min-w-56">
        <Typography level={6} fontWeight="bold">
          {props.label}
        </Typography>
      </div>
      <Typography level={6}>
        <span className="break-words">{props.value || '-'}</span>
      </Typography>
    </div>
  );
}

export default DataDisplay;

// export function DataDisplayV2(props: {
//   label: string,
//   value?: ReactNode,
//   alignments?: 'left' | 'right'
//   size?: number,
//   labelWrapperClassName?: string,
//   wrapperClassName?: string,
// }) {
//   const typographySize = Math.max(Math.min(props.size || 6, 8), 1) as any;

//   const Empty = () => (
//     <Typography level={typographySize} as="div">
//       <div
//         className={classJoin(
//           'w-full',
//           props.alignments === 'right' ? 'text-right' : 'text-left',
//         )}
//       >
//         {'-'}
//       </div>
//     </Typography>
//   );

//   return (
//     <div className={classJoin('flex items-baseline', props.wrapperClassName)}>
//       <div className={classJoin('min-w-48', props.labelWrapperClassName)}>
//         <Typography level={typographySize} fontWeight="bold" as="div">
//           <div className="text-gray-subtitle">{props.label}</div>
//         </Typography>
//       </div>
//       <div className="flex-grow">
//         <RenderIf
//           condition={typeof props.value === 'number'}
//           fallback={(
//             <RenderIf
//               condition={typeof props.value === 'string' || typeof props.value === 'boolean'}
//               fallback={props.value ?? <Empty />}
//             >
//               <Typography level={typographySize} as="div">
//                 <div
//                   className={classJoin(
//                     'w-full break-words',
//                     props.alignments === 'right' ? 'text-right' : 'text-left',
//                   )}
//                 >
//                   {props.value || <Empty />}
//                 </div>
//               </Typography>
//             </RenderIf>
//           )}
//         >
//           <Typography level={typographySize} as="div">
//             <div
//               className={classJoin(
//                 'w-full break-words',
//                 props.alignments === 'right' ? 'text-right' : 'text-left',
//               )}
//             >
//               {props.value ?? <Empty />}
//             </div>
//           </Typography>
//         </RenderIf>
//       </div>
//     </div>
//   );
// }
